import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import TdaCategoryTree from '../../Components/TdaCategoryTree';
import * as CatUtil from '../../Utils/CatUtil';
import * as NavUtil from '../../Utils/NavUtil';
import useArea from '../../Hooks/useArea';

export default function AboutLayout(props) {
  const {isDoctor} = useArea();
  const navItems = NavUtil.getNavItems({...props, isDoctor});

  const about = navItems.find((x) => (x.path ?? '').indexOf('/about') > -1);

  return (
    <Wrapper>
      <main className="tda-layout">
        <div className="nav">
          <TdaCategoryTree
            title={about?.name}
            root={{
              categories: (about?.entries || []).map((x) => ({
                url: x.path,
                name: x.name,
              })),
            }}
            location={props.location}
            checkSelected={({url}) =>
              NavUtil.sliceTailSlash(url) ===
              NavUtil.sliceTailSlash(props.location.pathname)
            }
          />
        </div>
        <div className="content">{props.children}</div>
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);
`;
